<qai-inner-wrap class="container">
  <div class="transcript-content">
    <!-- Header -->
    <div class="transcript-header">
      <span data-testId="callTranscript">{{'results.CALL_TRANSCRIPT' | transloco}}</span>
    </div>

    <div *ngIf="isLoadingTranscript" class="hang-tight-screen">
      <app-hang-tight
        [isErrorLoadingScreen]="isErrorLoadingScreen"
        [displayButtonLoadingScreen]="displayButtonLoadingScreen"
        [titleLoadingScreen]="titleLoadingScreen"
        [messageLoadingScreen]="messageLoadingScreen"
      >
      </app-hang-tight>
    </div>

    <!-- Messages -->
    <div *ngIf="transcript; else noTranscript" class="transcript-container">
      <div
        data-testId="transcript"
        class="transcript"
        [innerHTML]="transformedTranscript"
      ></div>
    </div>
    <ng-template #noTranscript>
      <div class="no-transcript">
        {{'results.NO_TRANSCRIPT' | transloco}}
      </div>
    </ng-template>

    <!-- Session ID -->
    <div class="session-id" *ngIf="practiceCallUuid && showFooter">
      <div
        data-testId="sessionId"
        class="text"
        (click)="copyText()"
        [matMenuTriggerFor]="tooltipMenu"
      >
        {{'results.SESSION_ID' | transloco}} {{ practiceCallUuid }}
      </div>
    </div>
    <mat-menu
      #tooltipMenu="matMenu"
      yPosition="above"
      hasBackdrop="false"
      class="tooltip-copy-session-id"
    >
      <div>{{'results.SESSION_ID_COPIED' | transloco}}</div>
    </mat-menu>
  </div>
</qai-inner-wrap>
